/// <amd-module name="DistributedTask/Common/SharedResources/Constants" />

export const enum PerformanceConstants {
    ResourcesHubFeature = "ResourcesHub",
    ResourcesHubScenario = "ResourcesHub.Loaded",

    EndpointTypeSelectionFeature = "EndpointTypeSelection",
    EndpointTypeSelectionScenario = "EndpointTypeSelection.Loaded",

    ServiceEndpointOverviewFeature = "ServiceEndpointOverviewTab",
    ServiceEndpointOverviewScenario = "ServiceEndpointOverviewTab.Loaded",

    EndpointEditorFeature = "EndpointEditor",
    EndpointEditorScenario = "EndpointEditor.Loaded"
}